module.exports = "/assets/data/165350ac0aadf06efd786ffd66162723-BN11.data.json";